var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"m16.95 7.05-9.9 9.9M7.05 7.05l9.9 9.9"})));
}

Plus.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
